import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';
const apiUrl = process.env.REACT_APP_API_URL;
function AdminEditBatch() {
  const { id } = useParams();
  const [courseName, setCourseName] = useState('');
  const [batchname, setBatchname] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  // Memoize fetchBatch with useCallback
  const fetchBatch = useCallback(async () => {
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setMessage('You must be logged in to edit a batch.');
        setMessageType('error');
        return;
      }
      const response = await axios.get(`${apiUrl}/api/admin/batchess/${id}?nocache=${Date.now()}`, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      if (response.data.success) {
        setCourseName(response.data.batch.course_name);
        setBatchname(response.data.batch.batchname);
      } else {
        setMessage(response.data.message || 'Failed to fetch batch.');
        setMessageType('error');
      }
    } catch (err) {
      setMessage(err.response?.data?.message || err.message || 'Error fetching batch.');
      setMessageType('error');
    }
  }, [id]); // Dependency on id, which changes with route params
  // Use useEffect with memoized functions
  useEffect(() => {
    fetchBatch();
  }, [fetchBatch]); // Use memoized functions in dependency array
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setMessageType('');
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setMessage('You must be logged in to edit a batch.');
        setMessageType('error');
        setLoading(false);
        return;
      }
      const response = await axios.put(`${apiUrl}/api/admin/batches/${id}`, { batchname }, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      if (response.data.success) {
        setMessage('Batch updated successfully!');
        setMessageType('success');
        setTimeout(() => navigate('/admin-view-batches'), 2000);
      } else {
        setMessage(response.data.message || 'Failed to update batch.');
        setMessageType('error');
      }
    } catch (err) {
      setMessage(err.response?.data?.message || err.message || 'Error updating batch.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link to="/admin-dashboard" className="text-gray-200 fw-normal text-15 hover-text-main-600">
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">Edit Batch</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="card overflow-hidden">
            <div className="card-body p-24">
              <h4 className="mb-16">Edit Batch</h4>
              {message && (
                <div className={`alert alert-${messageType} mb-16`}>
                  {message}
                </div>
              )}
              <form onSubmit={handleSubmit} className="mb-24">
                <div className="mb-3">
                  <label htmlFor="courseName" className="form-label">Course</label>
                  <input
                    type="text"
                    className="form-control"
                    id="courseName"
                    value={courseName}
                    disabled
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="batchname" className="form-label">Batch Name</label>
                  <input
                    type="text"
                    className="form-control"
                    id="batchname"
                    value={batchname}
                    onChange={(e) => setBatchname(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Updating...' : 'Update Batch'}
                </button>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
export default AdminEditBatch;